// src/pages/Inscription/Card.jsx
import React, { useState } from "react";
import { FaEdit, FaTrashAlt, FaInfoCircle } from "react-icons/fa";
import { deleteActeur } from "./../../services/acteursServices";
import EditActeurModalByUser from "./EditActeurModalByUser";
import InfoModal from "./InfoModal";
import { toast } from "react-toastify";

const Card = ({ acteur, fetchActeurs }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const handleDeleteActeur = async () => {
    if (!window.confirm("Voulez-vous vraiment supprimer cet acteur ?")) return;
    try {
      await deleteActeur(acteur.id);
      toast.success("Acteur supprimé avec succès");
      fetchActeurs();
    } catch (error) {
      console.error("Erreur lors de la suppression de l'acteur :", error);
      toast.error("Erreur lors de la suppression de l'acteur");
    }
  };

  const handleEdit = () => setIsEditModalOpen(true);
  const closeEditModal = () => {
    setIsEditModalOpen(false);
    fetchActeurs();
  };

  const openInfoModal = () => setIsInfoModalOpen(true);
  const closeInfoModal = () => setIsInfoModalOpen(false);

  const photoUrl = acteur.photo_url || "/img/user_avatar.jpg";
  const groupes = acteur.Groups ? acteur.Groups.map((group) => group.nom) : [];

  return (
    <>
      <div className="group flex flex-col md:flex-row bg-white/95 dark:bg-slate-900/95 border border-slate-200/80 dark:border-slate-700/80 rounded-2xl overflow-hidden shadow-md hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200">
        {/* Photo */}
        <div className="relative w-full h-40 md:w-40 md:h-auto flex-shrink-0 overflow-hidden bg-slate-200 dark:bg-slate-800">
          <img
            src={photoUrl}
            alt={`${acteur.nom} ${acteur.prenom}`}
            className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105"
          />
        </div>

        {/* Contenu */}
        <div className="flex flex-col flex-1 p-4">
          <div className="flex items-start justify-between gap-2">
            <div>
              <h3 className="text-base md:text-lg font-bold uppercase text-slate-900 dark:text-white font-montserrat">
                {acteur.nom} {acteur.prenom}
              </h3>
              {acteur.club_acteur && (
                <p className="mt-1 text-xs text-slate-500 dark:text-slate-300">
                  {acteur.club_acteur}
                </p>
              )}
              {acteur.licence_number && (
                <p className="text-[11px] text-slate-400 dark:text-slate-400">
                  Licence : {acteur.licence_number}
                </p>
              )}
            </div>

            {/* Bouton Infos (desktop) */}
            <button
              onClick={openInfoModal}
              className="hidden md:inline-flex items-center justify-center w-8 h-8 rounded-full bg-amber-50 dark:bg-amber-900/40 text-amber-600 dark:text-amber-300 hover:bg-amber-100 dark:hover:bg-amber-900 transition-colors"
              title="Voir la fiche complète"
            >
              <FaInfoCircle />
            </button>
          </div>

          {/* Groupes */}
          <div className="mt-3">
            <div className="text-[11px] font-semibold uppercase text-slate-500 dark:text-slate-300 mb-1">
              Groupes
            </div>
            <div className="flex flex-wrap gap-1.5">
              {groupes.length > 0 ? (
                groupes.map((group, index) => (
                  <span
                    key={index}
                    className="inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] bg-primary/10 text-primary font-medium"
                  >
                    {group}
                  </span>
                ))
              ) : (
                <span className="text-xs text-slate-400">
                  Aucun groupe assigné pour le moment
                </span>
              )}
            </div>
          </div>

          {/* Actions */}
          <div className="mt-4 flex items-center justify-between">
            {/* Bouton Infos (mobile) */}
            <button
              onClick={openInfoModal}
              className="inline-flex md:hidden items-center gap-1 text-xs font-medium text-amber-600 dark:text-amber-300"
            >
              <FaInfoCircle />
              <span>Voir la fiche</span>
            </button>

            <div className="flex gap-2 ml-auto">
              <button
                onClick={handleEdit}
                className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-300 hover:bg-blue-100 dark:hover:bg-blue-900 transition-colors"
                title="Modifier l'acteur"
              >
                <FaEdit />
              </button>
              <button
                onClick={handleDeleteActeur}
                className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-rose-50 dark:bg-rose-900/30 text-rose-600 dark:text-rose-300 hover:bg-rose-100 dark:hover:bg-rose-900 transition-colors"
                title="Supprimer l'acteur"
              >
                <FaTrashAlt />
              </button>
            </div>
          </div>
        </div>
      </div>

      <EditActeurModalByUser
        isOpen={isEditModalOpen}
        onClose={closeEditModal}
        acteur={acteur}
        refreshList={fetchActeurs}
      />

      <InfoModal isOpen={isInfoModalOpen} onClose={closeInfoModal} acteur={acteur} />
    </>
  );
};

export default Card;
